'use client'

import { useFieldValue, useForm } from 'form-atoms'
import { SelectTokenNetwork } from '@/src/components/form/select-token-network'
import { swapFormAtom } from '@/src/stores/swap/atoms'

interface NetworkSelectorProps {
  direction: 'from' | 'to'
}

export const NetworkSelector = ({ direction }: NetworkSelectorProps) => {
  const { fieldAtoms } = useForm(swapFormAtom)
  const value = useFieldValue(
    direction === 'from' ? fieldAtoms.from : fieldAtoms.to,
  )

  return (
    <SelectTokenNetwork
      chain={value?.chain ?? undefined}
      token={value?.token ?? undefined}
      direction={direction}
    />
  )
}
